/**
 * Телефон или компьютер — по ширине окна, а не по устройству.
 *
 * Граница 768 px: всё уже — одна колонка, нижняя панель разделов, переписка
 * на весь экран. Планшет и окно компьютера шире — прежняя раскладка.
 * Значение живое: поворот телефона и сужение окна переключают раскладку.
 */

import { useEffect, useState } from 'react';

export const MOBILE_QUERY = '(max-width: 767px)';

export function useMedia(query: string): boolean {
  const [matches, setMatches] = useState(() => typeof window !== 'undefined' && window.matchMedia(query).matches);
  useEffect(() => {
    const mql = window.matchMedia(query);
    const update = () => setMatches(mql.matches);
    update();
    mql.addEventListener('change', update);
    return () => mql.removeEventListener('change', update);
  }, [query]);
  return matches;
}

export const useIsMobile = (): boolean => useMedia(MOBILE_QUERY);
